import * as React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { PostCardMemo } from './PostCard';
import type { IPostListProps } from '@/@types/posts';

function PostList({
  posts,
  selectedIds,
  onSelectAll,
  onSelectPost,
  onPostClick,
  onEditPost,
  onDeletePost,
  onCancelGeneration,
}: IPostListProps) {
  const allSelected = posts.length > 0 && posts.every(p => selectedIds.has(p._id));
  const someSelected = posts.some(p => selectedIds.has(p._id));

  const handleSelectAllChange = (checked: boolean) => {
    onSelectAll(checked);
  };

  return (
    <div className="flex flex-col gap-2">
      {/* Select All Bar */}
      <div className="flex items-center justify-between rounded-lg bg-background-secondary px-4 py-3">
        <div className="flex items-center gap-3">
          <Checkbox
            checked={allSelected}
            onCheckedChange={handleSelectAllChange}
            className="h-[18px] w-[18px] rounded border-border"
            data-state={someSelected && !allSelected ? 'indeterminate' : undefined}
          />
          <span className="text-[13px] font-medium text-foreground-muted">Select all</span>
        </div>
        <span className="text-[13px] text-foreground-placeholder">{selectedIds.size} selected</span>
      </div>

      {/* Post Cards */}
      {posts.map(post => (
        <PostCardMemo
          key={post._id}
          post={post}
          isSelected={selectedIds.has(post._id)}
          onSelect={onSelectPost}
          onClick={onPostClick}
          onEdit={onEditPost}
          onDelete={onDeletePost}
          onCancel={onCancelGeneration}
        />
      ))}
    </div>
  );
}

const PostListMemo = React.memo(PostList);

export { PostListMemo };
